module.exports = __webpack_public_path__ + "img/404-computer.305386f3.svg";